import styled from "styled-components";
import { hexToRgba } from "../../utils/helper";
import { Grid } from "@mui/material";

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 5px 0px;
  //border: 1px solid black;
  font: normal normal 600 0.9vw/1vw Open Sans;
  & .MuiIconButton-root {
    color: ${({ theme }) => theme.colors.green};
    padding: 0px;
  }
`;

export const ToggleButtonContainer = styled(Grid)`
    margin: 7px 5px 2px 5px !important;
    padding: 10px;
    font: normal normal 550 13px/18px "Open Sans", sans-serif;
    background: #ffffff;
    border: 1px solid #007842;
    border-radius: 5px;
    opacity: 1;
`;

export const FileRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0px 0px;
  padding: 0px 16px 0px 16px;
  font: normal normal 600 0.9vw/1vw Open Sans;
  background-color: ${({ bgColor }) => hexToRgba(bgColor, 0.2)};

  & .MuiIconButton-root {
    color: ${({ theme }) => theme.colors.green};
    padding: 0px;
  }
`;

export const FormControlStyled = styled.div`
  width: ${({ wd }) => {
    if (wd) return `${wd};`;
    else return "100%;";
  }};
  & .MuiInputBase-root {
    margin-top: ${({ high }) => {
      if (high) return "5px !important;";
      else return "0px !important;";
    }};
  }
`;

export const AdministrativeHeader = styled.div`
  color: ${({ theme }) => theme.colors.green};
  text-align: left;
  font: ${({ main }) => {
    if (main) return "normal normal 550 13px/18px Open Sans;";
    else return "normal normal 500 13px/18px Open Sans;";
  }};
  letter-spacing: 0px;
  opacity: 1;
  align-items: center;
`;

export const AdministrativeLevelLabel = styled.div`
  text-align: left;
  font: ${({ main }) => {
    if (main) return "normal normal 550 13px/18px Open Sans;";
    else return "normal normal 500 13px/18px Open Sans;";
  }};
  letter-spacing: 0px;
  color: black;
  opacity: 1;
  align-items: center;
  display: flex;
`;

export const FormControlStyledName = styled.div`
  font: normal normal 550 13px/18px Open Sans;
  letter-spacing: 0px;
  color: black;
  padding: 2px 0px;
`;

export const HorizontalSeparator = styled.div`
  border-bottom: 1.5px solid #70707030;
  width: 100%;
  margin: 5px 0px 8px;
`;

export const SearchText = styled.div`
  font: normal normal 600 13px/18px Open Sans;
  letter-spacing: 0px;
  color: black;
`;

export const CustomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
  padding: 2px;
  margin: 0px 0px 1px;
  font: normal normal 600 1vw/1.1vw Open Sans;
  letter-spacing: 0px;
  background: ${({ clicked }) => {
    if (clicked) return "#007842 0% 0% no-repeat padding-box;";
    else return "#F0F0F0  0% 0% no-repeat padding-box;";
  }};
  opacity: 1;
  & .hover {
    background: ${({ theme }) => theme.colors.green};
  }
`;

export const IconWrapper1 = styled.div`
  padding: 3px 15px 3px 15px;
  height: 100%;
  position: static;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  background: ${({ clicked }) => {
    if (clicked)
      return "#transparent url(/assets/wireless.png') 0% 0% no-repeat padding-box;";
    else return "#transparent  0% 0% no-repeat padding-box;";
  }};
  color: ${({ clicked }) => {
    if (clicked) return "#FFFFFF;";
    else return "black;";
  }};
  cursor: pointer;
`;

export const IconWrapper2 = styled.div`
  margin: 0px 0px 0px 0px;
  padding: 0px 12px 0px 2px;
  border-right: 1px solid #ffffff;
  width: 20px;
  height: 20px;
  position: static;
  display: flex;
  opacity: 0.5;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ clicked }) => {
    if (clicked) return "#FFFFFF;";
    else return "black;";
  }};
`;

export const IconWrapper3 = styled.div`
  padding: 3px 2px 3px 0px;
  height: 90%;
  position: static;
  display: flex;
  opacity: 0.5;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ clicked }) => {
    if (clicked) return "#FFFFFF;";
    else return "black;";
  }};
`;

export const SidePanelCardTitle = styled.div`
  text-align: left;
  font: normal normal 600 13px/18px Open Sans;
  letter-spacing: 0px;
  color: ${({ clicked }) => {
    if (clicked) return "#FFFFFF;";
    else return "black;";
  }};
  opacity: 0.7;
  align-items: center;
  margin-left: ${({ leftAlign }) => {
    if (leftAlign) return "13px;";
    else return "0px;";
  }};
`;

export const SubTitleWrapper = styled.div`
  padding: "5px 0px";
  text-align: left;
  font: normal normal normal 14px/39px Open Sans;
  letter-spacing: 0px;
  color: black;
  opacity: 1;
  align-items: center;
`;

export const VerticalSeparator = styled.div`
  border-bottom: 2px solid #70707030;
  height: 80%;
  margin: 2px 5px 2px 5px;
  padding: 2px 0px;
  color: ${({ clicked }) => {
    if (clicked) return "#FFFFFF;";
    else return "black;";
  }};
`;

export const FileName = styled.p`
  text-align: left;
  font: normal normal 600 13px/13px Open Sans;
  letter-spacing: 0px;
  color: ${({ color }) => color};
  opacity: 1;
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  opacity: 1;
  transition: opacity 0.2s ease, visibility 0.2s ease;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  min-width: 30px;
`;

export const EmptyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100px;
`;
